<template>
  <div>
    <v-text-field
      v-model="keyword"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
      autocomplete="off"
      @input="search()"
      clearable
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "AppSearch",
  data: () => ({
    keyword: "",
  }),
  methods: {
    search() {
      let vm = this;
      vm.$emit("search", vm.keyword);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>